import { render, staticRenderFns } from "./ReviewPublished.vue?vue&type=template&id=3136f7e3"
import script from "./ReviewPublished.vue?vue&type=script&lang=js"
export * from "./ReviewPublished.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports